export const buildUrl = (baseUrl: string, params: string) => {
  const delimiter = baseUrl?.includes('?') ? '&' : '?';

  return `${baseUrl}${delimiter}${params}`;
};
